import React from "react"
import IntroSection from "../components/IntroSection";
import MobileSolution from "../components/MobileSolution";
import SoftwareProcess from "../components/SoftwareProcess";
import CustomerTestimonials from "../components/CustomerTestimonials";
import MobileBenefits from "../components/MobileBenefits";
import MobileAwards from "../components/MobileAwards";
import BlueSectionDivider from "../components/BlueSectionDivider";
import CountriesSection from "../components/CountriesSection";
import MobileReimagine from "../components/MobileReimagine";
import MobileProjects from "../components/MobileProjects";
import TeamSection from "../components/TeamSection";
import WhyUsSection from "../components/WhyUsSection";
import WorkingModelSection from "../components/WorkingModelSection";
import TechStackSection from "../components/TechStackSection";
import MobileFaq from "../components/MobileFaq";
import MobileResources from "../components/MobileResources";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
const MobileDevelopment = () =>{
    return(
        <div>
            <IntroSection title = "MOBILE APP DEVELOPMENT" paragraph ="High-end mobile app development services adjusted to your market needs." backgroundImage="/images/md-bg.webp"/>
            <MobileSolution/>
            <SoftwareProcess/>
           
            <MobileBenefits/>
            
            <BlueSectionDivider/>
            <CountriesSection/>
            <MobileReimagine/>
            <BlueSectionDivider/>
            <MobileProjects/>
            <TeamSection/>
            <WhyUsSection/>
            <WorkingModelSection/>
            <TechStackSection/>
            <MobileFaq/>
          
            <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>

        </div>
    )
}
export default MobileDevelopment;